// extracted by css-extract-rspack-plugin
export default {"loadingStatus":"StatusIcon-module__loadingStatus__URrNV"};